import React, { Fragment } from "react";
import Select from "react-select";

const SelectInput = ({
  input,
  value,
  type,
  onChange,
  placeholder,
  multiple,
  options,
  theme,
  meta: { touched, error },
  ...rest
}) => {
  let attachedClasses = ["form-group"];

  //  error={condition && value}, pass error={condition ? value : undefined}
  return (
    <div className={attachedClasses.join(" ")}>
      <Select
        value={
          input.value === ""
            ? null
            : options.find((obj) => obj.value === input.value)
        }
        onChange={input.onChange}
        // onBlur={input.onBlur}
        onFocus={input.onFocus}
        placeholder={placeholder}
        options={options}
        isMulti={multiple}
        theme={theme}
        {...rest}
      />
      {touched && error && <label className={"error"}>{error}</label>}
    </div>
  );
};

export default SelectInput;
